import React, { useRef, useState } from 'react';
import { resolvePlanBarcode } from './plan-barcode.mjs';
import './PlanBarcodeScan.css';

export default function PlanBarcodeScan({ items, disabled, busy, onScan, label = 'Product barcode' }) {
  const [raw, setRaw] = useState('');
  const [pending, setPending] = useState(null);
  const [color, setColor] = useState('');
  const [size, setSize] = useState('');
  const [localError, setLocalError] = useState('');
  const input = useRef(null);
  const colors = [...new Set((pending?.candidates || []).map(item => item.color))];
  const sizes = [...new Set((pending?.candidates || []).filter(item => item.color === color).map(item => item.size))];

  async function submit(event) {
    event.preventDefault();
    if (disabled || busy || !raw.trim()) return;
    setLocalError('');
    const result = resolvePlanBarcode(raw, items);
    if (result.kind === 'invalid') {
      setPending(null);
      setLocalError('ဒီ barcode ၏ product / colour / size သည် transfer စာရင်းနှင့် မကိုက်ပါ။');
      return;
    }
    if (result.kind === 'ambiguous') {
      setLocalError('တူညီသော product line များရှိသည်။ Warehouse မှ စာရင်းကို ပြန်စစ်ပါ။');
      return;
    }
    if (result.kind === 'select') {
      setPending({ raw: raw.trim(), candidates: result.candidates });
      setColor(''); setSize('');
      return;
    }
    const ok = await onScan({ raw: raw.trim(), itemId: result.item.id });
    if (ok) { setRaw(''); setPending(null); input.current?.focus(); }
  }

  async function confirmSelection() {
    if (!pending || !color || !size || disabled || busy) return;
    const selected = pending.candidates.find(item => item.color === color && item.size === size);
    if (!selected) { setLocalError('Colour နှင့် Size ကို စာရင်းထဲက မှန်ကန်သောတစ်ခု ရွေးပါ။'); return; }
    setLocalError('');
    const ok = await onScan({ raw: pending.raw, itemId: selected.id, selectedColor: color, selectedSize: size });
    if (ok) { setRaw(''); setPending(null); setColor(''); setSize(''); input.current?.focus(); }
  }

  return <div className="planBarcode">
    <form className="planBarcode__form" onSubmit={submit}>
      <label><span>{label}</span><input ref={input} aria-label={label} value={raw} disabled={disabled || !!busy} onChange={event => { setRaw(event.target.value); setPending(null); setLocalError(''); }} placeholder="Code သို့မဟုတ် Code-Colour-Size scan ဖတ်ပါ" autoComplete="off" /></label>
      <button type="submit" disabled={disabled || !!busy || !raw.trim()}>{busy ? 'Checking…' : 'Scan product'}</button>
    </form>
    {pending && <div className="planBarcode__select" role="group" aria-label="Select colour and size for code-only barcode">
      <strong>{pending.candidates[0].product_code}</strong><span>Barcode တွင် Colour/Size မပါပါ။ ပစ္စည်းပေါ်က Colour နှင့် Size ကို ရွေးပါ။</span>
      <label>Colour<select aria-label="Scanned product colour" value={color} disabled={disabled || !!busy} onChange={event => { setColor(event.target.value); setSize(''); }}><option value="">Colour ရွေးပါ</option>{colors.map(value => <option key={value} value={value}>{value}</option>)}</select></label>
      <label>Size<select aria-label="Scanned product size" value={size} disabled={disabled || !!busy || !color} onChange={event => setSize(event.target.value)}><option value="">Size ရွေးပါ</option>{sizes.map(value => <option key={value} value={value}>{value}</option>)}</select></label>
      <button type="button" disabled={disabled || !!busy || !color || !size} onClick={confirmSelection}>Confirm scan · 1 pc</button>
    </div>}
    {localError && <p className="planBarcode__error" role="alert">{localError}</p>}
  </div>;
}
